<app-nav></app-nav>

<!-- Debounced route overlay for longer navigations -->
<div class="route-overlay" *ngIf="loading$ | async" @overlayFade></div>

<div class="route-wrapper" [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"/>
</div>

<div class="progress-container">
  <div class="progress-bar" [style.width.%]="scrollPercentage"></div>
  
</div>

<app-footer></app-footer>
